type FeatureName = string;
type IsDisallowedByFeatureName = (featureName: FeatureName) => boolean;

const isDisabled = (input: string | null): boolean => {
  if (input === null) return false;
  return input === "false";
};

export const isDisallowedByFeatureName: IsDisallowedByFeatureName = (
  featureName
) => {
  const queryParameters = new URLSearchParams(window.location.search);

  if (isDisabled(queryParameters.get(featureName))) return true;

  return isDisabled(localStorage.getItem(featureName));
};
